var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TuxLoadingIndicator = (_a) => {
    var rest = __rest(_a, []);
    return (_jsxs("div", Object.assign({ className: "spinner" }, { children: [_jsxs("svg", Object.assign({}, rest, { height: "40px", viewBox: "0 0 40 40", width: "40px", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("circle", { className: "background-path", cx: "20", cy: "20", fill: "transparent", r: "18", stroke: "#ccc", strokeWidth: "4" }, void 0), _jsx("circle", { className: "path", cx: "20", cy: "20", fill: "transparent", r: "18", stroke: "#0e59a4", strokeWidth: "4" }, void 0)] }), void 0), _jsx("span", Object.assign({ className: "sr-only" }, { children: "Loading" }), void 0)] }), void 0));
};
export default TuxLoadingIndicator;
